// Phase-4 test IDs — KRA/360/9box, Payroll admin ext, Surveys, Onboarding, Ops-HR
export const KRA = {
  cycleSelect: "kra-cycle-select",
  addBtn: "kra-add-btn",
  saveBtn: "kra-save-btn",
  list: "kra-list",
  selfRating: (id) => `kra-self-${id}`,
  managerRating: (id) => `kra-manager-${id}`,
  finalRating: (id) => `kra-final-${id}`,
  rollupBtn: (eid) => `kra-rollup-${eid}`,
};

export const F360 = {
  requestBtn: "f360-request-btn",
  saveBtn: "f360-save-btn",
  reviewerList: "f360-reviewer-list",
  submitBtn: (id) => `f360-submit-${id}`,
};

export const NB = {
  cycleSelect: "ninebox-cycle-select",
  setBtn: (eid) => `ninebox-set-${eid}`,
  cell: (p, pot) => `ninebox-cell-${p}-${pot}`,
};

export const PAYX = {
  tabAdj: "payx-tab-adj",
  tabLoans: "payx-tab-loans",
  tabFnF: "payx-tab-fnf",
  tabReimb: "payx-tab-reimb",
  tabBank: "payx-tab-bank",
  adjCreateBtn: "adj-create-btn",
  adjSaveBtn: "adj-save-btn",
  loanCreateBtn: "loan-create-btn",
  loanSaveBtn: "loan-save-btn",
  fnfCreateBtn: "fnf-create-btn",
  fnfSaveBtn: "fnf-save-btn",
  fnfFinalizeBtn: (id) => `fnf-finalize-${id}`,
  fnfPayBtn: (id) => `fnf-pay-${id}`,
  bankExportBtn: "bank-export-btn",
};

export const SURV = {
  createBtn: "survey-create-btn",
  saveBtn: "survey-save-btn",
  addQBtn: "survey-add-q-btn",
  takeBtn: (id) => `survey-take-${id}`,
  submitBtn: "survey-submit-btn",
  resultsBtn: (id) => `survey-results-${id}`,
};

export const ONB = {
  startOnBtn: "onb-start-btn",
  startOffBtn: "off-start-btn",
  wfList: "wf-list",
  taskToggle: (wid, key) => `wf-task-${wid}-${key}`,
  docsUploadBtn: "doc-upload-btn",
  docsAddBtn: "doc-add-btn",
};

export const OPS = {
  tabTickets: "ops-tab-tickets",
  tabAssets: "ops-tab-assets",
  tabCourses: "ops-tab-courses",
  tabSkills: "ops-tab-skills",
  ticketCreateBtn: "ticket-create-btn",
  ticketSaveBtn: "ticket-save-btn",
  assetIssueBtn: "asset-issue-btn",
  assetSaveBtn: "asset-save-btn",
  assetReturnBtn: (id) => `asset-return-${id}`,
  courseCreateBtn: "course-create-btn",
  courseSaveBtn: "course-save-btn",
  enrollBtn: "course-enroll-btn",
  completeBtn: (id) => `enroll-complete-${id}`,
  skillAddBtn: "skill-add-btn",
};
